/* wbx-header.js: hover-open for the desktop menus, one open at a time, Escape closes,
   keeps the sheet inside the viewport. Click, keyboard and focus-out close stay Dawn's.
   Loaded only by sections/wbx-header.liquid. */
(function () {
  if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
  var hdr = document.querySelector('.wbx-hdr');
  if (!hdr) return;
  var menus = Array.prototype.slice.call(hdr.querySelectorAll('.wbx-nav details.wbx-has'));
  if (!menus.length) return;
  var OPEN_DELAY = 70, CLOSE_DELAY = 160, timers = new Map();

  function fit(d) {
    var dd = d.querySelector('.wbx-dd');
    if (!dd) return;
    dd.style.removeProperty('--wbx-shift');
    var r = dd.getBoundingClientRect(), vw = document.documentElement.clientWidth, over = r.right - (vw - 16);
    if (over > 0) dd.style.setProperty('--wbx-shift', (-over) + 'px');
    var s = d.querySelector('summary').getBoundingClientRect();
    dd.style.setProperty('--wbx-arrow', Math.round(s.left + s.width / 2 - (r.left - Math.max(over, 0)) - 6) + 'px');
  }
  function open(d) {
    menus.forEach(function (o) { if (o !== d && o.open) o.removeAttribute('open'); });
    if (!d.open) d.setAttribute('open', '');
    d.querySelector('summary').setAttribute('aria-expanded', 'true');
    fit(d);
  }
  function close(d) {
    if (d.open) d.removeAttribute('open');
    d.querySelector('summary').setAttribute('aria-expanded', 'false');
  }
  menus.forEach(function (d) {
    var wrap = d.parentElement; /* <header-menu> */
    wrap.addEventListener('mouseenter', function () {
      clearTimeout(timers.get(d)); timers.set(d, setTimeout(function () { open(d); }, OPEN_DELAY));
    });
    wrap.addEventListener('mouseleave', function () {
      clearTimeout(timers.get(d)); timers.set(d, setTimeout(function () { close(d); }, CLOSE_DELAY));
    });
    d.addEventListener('toggle', function () {
      d.querySelector('summary').setAttribute('aria-expanded', d.open ? 'true' : 'false');
      if (d.open) { menus.forEach(function (o) { if (o !== d && o.open) o.removeAttribute('open'); }); fit(d); }
    });
  });
  hdr.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    menus.forEach(function (d) { if (d.open) { close(d); d.querySelector('summary').focus(); } });
  });
  window.addEventListener('resize', function () { menus.forEach(function (d) { if (d.open) fit(d); }); });
})();
